import { AISystem } from '../config/ai';

export interface AIAdapterResponse {
  rawText: string;
  modelVersion: string;
  timestamp: Date;
  sources?: string[]; // For web-grounded systems
}

export interface AIAdapter {
  readonly system: AISystem;
  readonly name: string;

  /**
   * Send a prompt to the AI system and get a response
   * @param prompt The prompt text to send
   * @returns The AI response
   */
  query(prompt: string): Promise<AIAdapterResponse>;

  /**
   * Check if the adapter is properly configured
   */
  isConfigured(): boolean;

  /**
   * Get the caching strategy for this adapter
   */
  getCacheTTL(): number; // in milliseconds
}

export abstract class BaseAIAdapter implements AIAdapter {
  abstract readonly system: AISystem;
  abstract readonly name: string;
  protected abstract apiKey: string;

  abstract query(prompt: string): Promise<AIAdapterResponse>;

  isConfigured(): boolean {
    return !!this.apiKey && this.apiKey.length > 0;
  }

  abstract getCacheTTL(): number;

  protected handleError(error: any, systemName: string): never {
    console.error(`${systemName} Error:`, error);
    throw new Error(`${systemName} query failed: ${error.message || 'Unknown error'}`);
  }
}
